// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_header__\\+ubXf {
    height: 8vh;
    display: flex;
    justify-content: space-between;
    background-color: #868b64;
    align-items: center;
    padding-right: 2rem;
}
.Layout_title__QXN9c {
    font-size: 2rem;
    font-weight: bold;
    padding-left: 1rem;
    color: #fff;
}
.Layout_logo__fHLfX {
    font-size: 2rem;
    font-weight: bold;
    padding-left: 1rem;
}
.Layout_layout__lvFj1 {
    height: 100vh;
}
.Layout_sidebar__ccj\\+\\+ {
    display: flex;
    flex-direction: column;
    /* width: 20%; */
    height: 95vh;
    background-color: #a5a5aa;
}
.Layout_nav-link__pYW3\\+ {
font-size: 1.5rem;
text-decoration: none;
color: black;
text-align: center;
padding-top: 0.5rem;
padding-bottom: 0.5rem;
}
.Layout_active__yc\\+Pl {
    background-color: #474747;
    color: white;
}
.Layout_container__Ok0Lo {
    display: flex;
}
.Layout_mainContainer__gAXGr {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Common/Components/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;AACA;AACA,iBAAiB;AACjB,qBAAqB;AACrB,YAAY;AACZ,kBAAkB;AAClB,mBAAmB;AACnB,sBAAsB;AACtB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf","sourcesContent":[".header {\n    height: 8vh;\n    display: flex;\n    justify-content: space-between;\n    background-color: #868b64;\n    align-items: center;\n    padding-right: 2rem;\n}\n.title {\n    font-size: 2rem;\n    font-weight: bold;\n    padding-left: 1rem;\n    color: #fff;\n}\n.logo {\n    font-size: 2rem;\n    font-weight: bold;\n    padding-left: 1rem;\n}\n.layout {\n    height: 100vh;\n}\n.sidebar {\n    display: flex;\n    flex-direction: column;\n    /* width: 20%; */\n    height: 95vh;\n    background-color: #a5a5aa;\n}\n.nav-link {\nfont-size: 1.5rem;\ntext-decoration: none;\ncolor: black;\ntext-align: center;\npadding-top: 0.5rem;\npadding-bottom: 0.5rem;\n}\n.active {\n    background-color: #474747;\n    color: white;\n}\n.container {\n    display: flex;\n}\n.mainContainer {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Layout_header__+ubXf`,
	"title": `Layout_title__QXN9c`,
	"logo": `Layout_logo__fHLfX`,
	"layout": `Layout_layout__lvFj1`,
	"sidebar": `Layout_sidebar__ccj++`,
	"nav-link": `Layout_nav-link__pYW3+`,
	"active": `Layout_active__yc+Pl`,
	"container": `Layout_container__Ok0Lo`,
	"mainContainer": `Layout_mainContainer__gAXGr`
};
export default ___CSS_LOADER_EXPORT___;
